module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', _vm._b({
    ref: "form",
    class: [
      'rt-form',
      'is-' + _vm.labelColor,
      _vm.labelColon ? 'is-label-colon' : '',
      _vm.border ? 'is-border-form' : ''
    ],
    attrs: {
      "inline": _vm.inline,
      "label-position": "top",
      "all-clearable": _vm.allClearable
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, 'el-form', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e93df5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtForm.vue
// module id = 2144
// module chunks = 228